<p-stepper #customStepper>
  <p-stepperPanel>
    <ng-template pTemplate="header" let-onClick="onClick" let-index="index">
      <div class="step-header">
        <div>
          <!-- Normal Icon -->
          <div
            class="step-icon active-step"
            *ngIf="!this.isStepCompleted.stepOne"
          >
            <div class="pending-icon"></div>
          </div>

          <!-- Step Completed Icon -->
          <div
            class="step-icon step-completed"
            *ngIf="this.isStepCompleted.stepOne"
          >
            <div class="completed-icon">
              <ng-icon name="hugeTick01" size="1.2em" color="#fff"></ng-icon>
            </div>
          </div>
        </div>
        <div class="header-title active-step">
          <p class="b2 font-medium m-b-0 m-t-8">Create Backlogs</p>
        </div>
      </div>
    </ng-template>
    <ng-template
      pTemplate="content"
      let-nextCallback="nextCallback"
      let-index="index"
    >
      <form
        [formGroup]="backlogsForm"
        (ngSubmit)="onBacklogsSubmit(nextCallback, false)"
      >
        <div class="dis-flex" style="gap: 24px">
          <div class="summary-box">
            <h3 class="font-medium text-100">Summary</h3>
            <p-divider class="horizontal-divider" />
            <p-scrollPanel
              [style]="{ width: '100%', height: 'calc(100vh - 50vh)' }"
            >
              <div class="summary-list">
                @if(annualOutcomeName) {
                <b style="font-weight: 600">&nbsp;&nbsp;MTO</b>
                <ul>
                  <li
                    [ngbTooltip]="annualOutcomeName"
                    showDelay="1000"
                    hideDelay="300"
                  >
                    {{ showHintValue(annualOutcomeName) }}
                  </li>
                </ul>
                }
              </div>
            </p-scrollPanel>
          </div>
          <div
            class="wizard-form mto-group-dropdown"
            #mtoParent
            style="position: relative"
          >
            <p-scrollPanel
              [style]="{ width: '100%', height: 'calc(100vh - 40vh)' }"
            >
              <div class="row m-b-15">
                <div class="col-md-12 b2 text-90 m-b-20">
                  <p-checkbox
                    [(ngModel)]="createBacklogSomeone"
                    [binary]="true"
                    [ngModelOptions]="{ standalone: true }"
                    (onChange)="addNameFieldConditionally($event)"
                  />
                  &nbsp;&nbsp; Do you want to create backlog for someone else?
                </div>

                <div class="col-md-9">
                  <div class="d-flex">
                    <label class="b2 text-90"
                      >Group <span class="mandatory">*</span></label
                    >
                    <div
                      *ngIf="
                        backlogsForm.get('group')?.invalid &&
                        backlogsForm.get('group')?.touched
                      "
                      class="error-message"
                    >
                      Group is required
                    </div>
                  </div>
                  <p-dropdown
                    class="wizard-field"
                    formControlName="group"
                    optionLabel="label"
                    optionValue="value"
                    [options]="groupFilter"
                    placeholder="Select"
                    (onChange)="onGroupChange($event)"
                    filter="true"
                    (onFilter)="onGroupSearch($event)"
                    [overlayOptions]="helper.getOverlayOptions()"
                  />
                </div>
                <div class="col-md-3">
                  <div class="d-flex">
                    <label class="b2 text-90"
                      >Year <span class="mandatory">*</span></label
                    >
                    <div
                      *ngIf="
                        backlogsForm.get('year')?.invalid &&
                        backlogsForm.get('year')?.touched
                      "
                      class="error-message"
                    >
                      Year is required
                    </div>
                  </div>

                  <p-dropdown
                    class="wizard-field"
                    [overlayOptions]="helper.getOverlayOptions()"
                    formControlName="year"
                    [options]="yearFilter"
                    placeholder="Select"
                    (onChange)="onYearChange($event)"
                  >
                  </p-dropdown>
                </div>
              </div>

              <div *ngIf="backlogsForm.get('name')" class="row m-b-15">
                <div class="col-md-12">
                  <div class="d-flex">
                    <label class="b2 text-90"
                      >Name <span class="mandatory">*</span></label
                    >
                    <div
                      *ngIf="
                        backlogsForm.get('name')?.invalid &&
                        backlogsForm.get('name')?.touched
                      "
                      class="error-message"
                    >
                      Name is required
                    </div>
                  </div>

                  <p-dropdown
                    class="wizard-field"
                    formControlName="name"
                    optionLabel="name"
                    optionValue="user_id"
                    [options]="members"
                    placeholder="Select"
                    (onChange)="onSelectMember($event)"
                    filter="true"
                    [overlayOptions]="helper.getOverlayOptions()"
                  />
                </div>
              </div>

              <div class="row m-b-15">
                <div class="col-md-12">
                  <div class="d-flex">
                    <label class="b2 text-90"
                      >MTO <span class="mandatory">*</span></label
                    >
                    <div
                      *ngIf="
                        backlogsForm.get('annualOutcome')?.invalid &&
                        backlogsForm.get('annualOutcome')?.touched
                      "
                      class="error-message"
                    >
                      MTO is required
                    </div>
                  </div>

                  <p-dropdown
                    class="wizard-field annual-outcome-dd"
                    formControlName="annualOutcome"
                    optionLabel="value"
                    optionValue="outcome_id"
                    [options]="annualOutcomesFilter"
                    placeholder="Select"
                    (onChange)="onAnnualOutcomeChange($event)"
                    filter="true"
                    (onFilter)="onAnnualOutcomeSearch($event)"
                    [overlayOptions]="helper.getOverlayOptions()"
                    [appendTo]="mtoParent"
                  />
                </div>
              </div>

              <div class="row m-b-15" formArrayName="backlogs">
                <div
                  class="col-md-12"
                  *ngFor="let backlog of backlogs.controls; let i = index"
                  [formGroupName]="i"
                >
                  <div class="d-flex">
                    <label class="b3 text-90"
                      >Backlog Title <span class="mandatory">*</span></label
                    >
                    <div
                      *ngIf="
                        backlog.invalid && (backlog.dirty || backlog.touched)
                      "
                      class="error-message"
                    >
                      Backlog Title is required
                    </div>
                  </div>

                  <textarea
                    class="wizard-field b2 text-90"
                    formControlName="title"
                    rows="2"
                    pInputTextarea
                  ></textarea>

                  <div class="row m-t-10">
                    <div class="col-md-2">
                      @if(backlogs.controls.length !== 1) {
                      <button
                        class="btn delete-btn m-b-20 b2 h-28 fs-12 wd-70"
                        (click)="backlogs.removeAt(i)"
                      >
                        Delete
                      </button>
                      }
                    </div>
                    <div
                      class="col-md-2 offset-md-8"
                      *ngIf="backlogs.controls.length - 1 === i"
                    >
                      <button
                        class="btn outline b2 h-28 fs-12 wd-70"
                        (click)="addMoreBacklogs()"
                      >
                        Add More
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <button type="submit">Submit</button> -->
            </p-scrollPanel>
          </div>
        </div>
        <div class="flex justify-content-end">
          <div class="dis-flex">
            <!-- <button class="btn primary wd-100px m-r-10 m-t-20"  type="submit" (click)="nextCallback.emit()">
            Next
          </button> -->
            @if(createBacklogSomeone) {
            <button
              type="button"
              class="btn primary wd-100px m-r-10 m-t-20"
              (click)="onClose()"
            >
              Cancel
            </button>
            <button class="btn success wd-100px m-t-20" type="submit">
              Done
            </button>

            } @else {
            <button class="btn primary wd-100px m-r-10 m-t-20" type="submit">
              Next
            </button>
            <button
              type="button"
              class="btn success wd-100px m-t-20"
              (click)="onDoneBacklogsSubmit('', true)"
            >
              Done
            </button>
            }
          </div>
        </div>
      </form>
    </ng-template>
  </p-stepperPanel>
  <p-stepperPanel>
    <ng-template pTemplate="header" let-onClick="onClick" let-index="index">
      <div class="step-header">
        <!-- Normal Icon -->
        <div
          class="step-icon active-step"
          *ngIf="!this.isStepCompleted.stepTwo"
        >
          <div class="pending-icon"></div>
        </div>

        <!-- Step Completed Icon -->
        <div
          class="step-icon step-completed"
          *ngIf="this.isStepCompleted.stepTwo"
        >
          <div class="completed-icon">
            <ng-icon name="hugeTick01" size="1.2em" color="#fff"></ng-icon>
          </div>
        </div>
        <div class="header-title">
          <p
            class="b2 m-b-0 m-t-8"
            ngbTooltip="Transform Backlogs to Short Term Outcomes"
          >
            Transform Backlogs to STO
          </p>
        </div>
      </div>
    </ng-template>
    <ng-template
      pTemplate="content"
      let-prevCallback="prevCallback"
      let-nextCallback="nextCallback"
      let-index="index"
    >
      <form
        [formGroup]="quarterlyOutcomeForm"
        (ngSubmit)="onQuarterlyOutcomesSubmit(nextCallback, false)"
      >
        <div class="dis-flex" style="gap: 24px">
          <div class="summary-box">
            <h3 class="font-medium text-100">Summary</h3>
            <p-divider class="horizontal-divider" />
            <p-scrollPanel
              [style]="{ width: '100%', height: 'calc(100vh - 50vh)' }"
            >
              <div class="summary-list">
                @if(annualOutcomeName) {
                <b style="font-weight: 600">&nbsp;&nbsp;MTO</b>
                <ul>
                  <li
                    [ngbTooltip]="annualOutcomeName"
                    showDelay="1000"
                    hideDelay="300"
                  >
                    {{ showHintValue(annualOutcomeName) }}
                  </li>
                  @if(backlogsListing.length) {
                  <b style="color: blue; font-weight: 600">Backlog</b>
                  <ul>
                    <li
                      *ngFor="let backlog of backlogsListing"
                      [ngbTooltip]="backlog['value']"
                      showDelay="1000"
                      hideDelay="300"
                    >
                      {{ showHintValue(backlog["value"]) }}
                    </li>
                  </ul>
                  }
                </ul>
                } @else {
                <b style="font-weight: 600">&nbsp;&nbsp;MTO</b>
                <ul>
                  <li
                    [ngbTooltip]="'Medium Term Outcomes'"
                    showDelay="1000"
                    hideDelay="300"
                  >
                    MTO
                  </li>
                  <b style="color: blue; font-weight: 600"
                    >&nbsp;&nbsp;Backlog</b
                  >
                  <ul>
                    <li
                      *ngFor="let backlog of backlogsListing"
                      [ngbTooltip]="backlog['value']"
                      showDelay="1000"
                      hideDelay="300"
                    >
                      {{ showHintValue(backlog["value"]) }}
                    </li>
                  </ul>
                </ul>
                }
              </div>
            </p-scrollPanel>
          </div>

          <div class="wizard-form" #formStepTwo style="position: relative;">
            <p-scrollPanel
              [style]="{ width: '100%', height: 'calc(100vh - 40vh)' }"
            >
              <div formArrayName="quarterly_outcomes">
                <div
                  *ngFor="
                    let outcome of quarterlyOutcomes.controls;
                    let i = index
                  "
                  [formGroupName]="i"
                  class="outcome-form"
                >
                  <div class="row m-b-15">
                    <div class="col-md-12">
                      <label class="b3 text-90">Backlog</label>
                      <input
                        type="text"
                        class="wizard-field b2 text-90"
                        [disabled]="true"
                        [value]="this.backlogsListing[i]['value']"
                      />
                    </div>
                  </div>
                  <div formArrayName="fields">
                    <div
                      *ngFor="let field of getFields(i).controls; let j = index"
                      [formGroupName]="j"
                      class="outcome-form-fields"
                    >
                      <!-- Quarterly Outcome Title (Textbox) -->
                      <div class="row m-b-15">
                        <div class="col-md-12">
                          <div class="d-flex">
                            <label
                              class="b3 text-90"
                              for="quarterlyOutcomeTitle"
                              >STO Title <span class="mandatory">*</span></label
                            >
                            <div
                              *ngIf="
                                field.get('title')?.invalid &&
                                field.get('title')?.touched
                              "
                              class="error-message"
                            >
                              Title is required
                            </div>
                          </div>

                          <input
                            formControlName="title"
                            id="quarterlyOutcomeTitle"
                            type="text"
                            class="wizard-field b2 text-90"
                          />
                        </div>
                      </div>

                      <div class="row m-b-15">
                        <div class="col-md-6">
                          <div class="d-flex">
                            <label class="b3 text-90"
                              >Cycle <span class="mandatory">*</span></label
                            >
                            <div
                              *ngIf="
                                field.get('quarter')?.invalid &&
                                field.get('quarter')?.touched
                              "
                              class="error-message"
                            >
                              Cycle is required
                            </div>
                          </div>

                          <p-dropdown
          formControlName="quarter"
          [overlayOptions]="helper.getOverlayOptions()"
          class="wizard-field cycle-dd"
          optionLabel="quarterVal"
          optionValue="quarter"
          [options]="quarter"
          placeholder="Select Quarter"
          appendTo="formStepTwo"
          (onChange)="onQuarterChange($event, j)"
          [filter]="true"
        >
          <ng-template let-quarter pTemplate="item">
            <div [ngClass]="{ 'disabled-option': isQuarterDisabled(quarter.quarter) }">
              {{ quarter.quarterVal }}
            </div>
          </ng-template>
        </p-dropdown>


                        

                          <!-- <p-dropdown
                            formControlName="quarter"
                            [overlayOptions]="helper.getOverlayOptions()"
                            class="wizard-field cycle-dd"
                            optionLabel="quarterVal"
                            optionValue="quarter"
                            [options]="quarter"
                            placeholder="Select"
                            appendTo="formStepTwo"
                          /> -->
                        </div>
                        <div class="col-md-6">
                          <div class="d-flex">
                            <label class="b3 text-90"
                              >Type of Work
                              <span class="mandatory">*</span></label
                            >
                            <div
                              *ngIf="
                                field.get('type')?.invalid &&
                                field.get('type')?.touched
                              "
                              class="error-message"
                            >
                              Type of work is required
                            </div>
                          </div>

                          <p-dropdown
                            formControlName="type"
                            class="wizard-field type-of-work-dd"
                            optionLabel="label"
                            optionValue="value"
                            [options]="typeOfWork"
                            placeholder="Select"
                            [overlayOptions]="helper.getOverlayOptions()"
                            appendTo="formStepTwo"
                          />
                        </div>
                      </div>

                      <div class="col-md-2">
                        @if(!(getFields(i).length <= 1)) {
                        <button
                          type="button"
                          class="btn delete-btn m-b-20 b2 h-28 fs-12 wd-70"
                          (click)="removeFields(i, j)"
                        >
                          Delete
                        </button>
                        }
                      </div>
                    </div>
                  </div>

                  <div class="col-md-2 offset-md-10">
                    <button
                      type="button"
                      class="btn outline b2 h-28 fs-12 wd-70"
                      (click)="addMoreOutcomes(i)"
                    >
                      Add More
                    </button>
                  </div>

                  <!-- <div class="row m-t-10 m-b-15">
                    <div class="col-md-2">
                      @if(quarterlyOutcomes.controls.length !== 1) {
                      <button class="btn delete-btn m-b-20 b2 h-28 fs-12 wd-70" (click)="quarterlyOutcomes.removeAt(i)">Delete</button>
                      }
                    </div>
                    <div class="col-md-2 offset-md-8" *ngIf="(quarterlyOutcomes.controls.length - 1) === i ">
                      <button class="btn outline b2 h-28 fs-12 wd-70" (click)="addMoreOutcomes()">Add More</button>
                    </div>
                  </div> -->

                  <!-- <p-divider class="horizontal-divider" /> -->
                </div>
              </div>
            </p-scrollPanel>
          </div>
        </div>
        <div class="dis-flex flex-sb">
          <div class="dis-flex">
            <button
              type="button"
              *ngIf="isStartOver"
              class="btn black m-r-10 m-t-20"
              (click)="onStartOver(index)"
            >
              Start Over
            </button>
          </div>
          <div class="dis-flex">
            <button
              *ngIf="!isDisabled"
              type="button"
              class="btn outline wd-100px m-r-10 m-t-20"
              (click)="onBackClick(prevCallback, quarterlyOutcomeForm)"
              [disabled]="isDisabled"
            >
              Back
            </button>
            <button
              class="btn primary wd-100px m-r-10 m-t-20"
              type="submit"
              [disabled]="quarterlyOutcomeForm.invalid"
            >
              Next
            </button>
            <button
              type="button"
              class="btn success wd-100px m-t-20"
              (click)="onQuarterlyOutcomesSubmit(nextCallback, true)"
              [disabled]="quarterlyOutcomeForm.invalid"
            >
              Done
            </button>
          </div>
        </div>
      </form>
    </ng-template>
  </p-stepperPanel>
  <p-stepperPanel>
    <ng-template pTemplate="header" let-onClick="onClick" let-index="index">
      <div class="step-header">
        <!-- Normal Icon -->
        <div
          class="step-icon active-step"
          *ngIf="!this.isStepCompleted.stepThree"
        >
          <div class="pending-icon"></div>
        </div>

        <!-- Step Completed Icon -->
        <div
          class="step-icon step-completed"
          *ngIf="this.isStepCompleted.stepThree"
        >
          <div class="completed-icon">
            <ng-icon name="hugeTick01" size="1.2em" color="#fff"></ng-icon>
          </div>
        </div>
        <div class="header-title">
          <p class="b2 m-b-0 m-t-8">Add Milestones</p>
        </div>
      </div>
    </ng-template>
    <ng-template
      pTemplate="content"
      let-prevCallback="prevCallback"
      let-index="index"
    >
      <form [formGroup]="milestonesForm" (ngSubmit)="onMilestonesSubmit()">
        <div class="dis-flex" style="gap: 24px">
          <div class="summary-box">
            <h3 class="font-medium text-100">Summary</h3>
            <p-divider class="horizontal-divider" />
            <p-scrollPanel
              [style]="{ width: '100%', height: 'calc(100vh - 50vh)' }"
            >
              <div class="summary-list">
                @if(annualOutcomeName) {
                <b style="font-weight: 600">&nbsp;&nbsp;MTO</b>
                <ul>
                  <li
                    [ngbTooltip]="annualOutcomeName"
                    showDelay="1000"
                    hideDelay="300"
                  >
                    {{ showHintValue(annualOutcomeName) }}
                  </li>
                  @if(mileStoneSummary.length) {
                  <b style="font-weight: 600">&nbsp;&nbsp;Backlog</b>
                  <ul>
                    <ng-container *ngFor="let item of mileStoneSummary">
                      <li
                        [ngbTooltip]="item['value']"
                        showDelay="1000"
                        hideDelay="300"
                      >
                        {{ showHintValue(item["value"]) }}
                      </li>
                      @if(item?.quartlyOutcome.length) {
                      <b style="color: blue; font-weight: 600"
                        >&nbsp;&nbsp;STO</b
                      >
                      <ul>
                        <ng-container
                          *ngFor="let outcome of item['quartlyOutcome']"
                        >
                          <li
                            [ngbTooltip]="outcome['value']"
                            showDelay="1000"
                            hideDelay="300"
                          >
                            {{ showHintValue(outcome["value"]) }}
                          </li>
                        </ng-container>
                      </ul>
                      }
                    </ng-container>
                  </ul>
                  }
                </ul>
                } @else {
                <b style="font-weight: 600">&nbsp;&nbsp;MTO</b>
                <ul>
                  <li
                    [ngbTooltip]="'Medium Term Outcomes'"
                    showDelay="1000"
                    hideDelay="300"
                  >
                    MTO
                  </li>
                  @if(mileStoneSummary.length) {
                  <b style="font-weight: 600">&nbsp;&nbsp;Backlog</b>
                  <ul>
                    <ng-container *ngFor="let item of mileStoneSummary">
                      <li
                        [ngbTooltip]="item['value']"
                        showDelay="1000"
                        hideDelay="300"
                      >
                        {{ showHintValue(item["value"]) }}
                      </li>
                      @if(item?.quartlyOutcome.length) {
                      <b style="color: blue; font-weight: 600"
                        >&nbsp;&nbsp;STO</b
                      >
                      <ul>
                        <ng-container
                          *ngFor="let outcome of item['quartlyOutcome']"
                        >
                          <li
                            [ngbTooltip]="outcome['value']"
                            showDelay="1000"
                            hideDelay="300"
                          >
                            {{ showHintValue(outcome["value"]) }}
                          </li>
                        </ng-container>
                      </ul>
                      }
                    </ng-container>
                  </ul>
                  } @else {
                  <b style="font-weight: 600">&nbsp;&nbsp;Backlog</b>
                  <ul>
                    <li
                      [ngbTooltip]="detailOutcomeData.value"
                      showDelay="1000"
                      hideDelay="300"
                    >
                      {{ showHintValue(detailOutcomeData.value) }}
                    </li>
                    @if(detailOutcomeData.quarterly.length) {
                    <b style="color: blue; font-weight: 600">&nbsp;&nbsp;STO</b>
                    <ul>
                      <ng-container
                        *ngFor="let outcome of detailOutcomeData.quarterly"
                      >
                        <li
                          [ngbTooltip]="outcome['value']"
                          showDelay="1000"
                          hideDelay="300"
                        >
                          {{ showHintValue(outcome["value"]) }}
                        </li>
                      </ng-container>
                    </ul>
                    }
                  </ul>
                  }
                </ul>
                }
              </div>
            </p-scrollPanel>
          </div>
          <div class="wizard-form">
            <p-scrollPanel
              [style]="{ width: '100%', height: 'calc(100vh - 40vh)' }"
            >
              <div formArrayName="milestones">
                <div
                  *ngFor="let milestone of milestones.controls; let i = index"
                  [formGroupName]="i"
                  class="quarterly-outcome-row"
                >
                  <div class="row m-b-15">
                    <div class="col-md-12">
                      <label class="b3 text-90">STO</label>
                      <input
                        type="text"
                        class="wizard-field b2"
                        [disabled]="true"
                        [value]="this.quarterlyListing[i]['value']"
                      />
                    </div>
                  </div>

                  <div formArrayName="fields">
                    <div
                      *ngFor="
                        let field of getMilestonesFields(i).controls;
                        let j = index
                      "
                      [formGroupName]="j"
                      class="outcome-form-fields"
                    >
                      <div class="row m-b-15">
                        <div class="col-md-12">
                          <div class="d-flex">
                            <label class="b3 text-90"
                              >Milestone Title
                              <span class="mandatory">*</span></label
                            >
                            <div
                              *ngIf="
                                field.get('title')?.invalid &&
                                field.get('title')?.touched
                              "
                              class="error-message"
                            >
                              Type of work is required
                            </div>
                          </div>
                          <input
                            formControlName="title"
                            id="milestoneTitle"
                            type="text"
                            class="wizard-field b2 text-90"
                          />
                        </div>
                      </div>

                      <div class="row m-b-15">
                        <div class="col-md-4">
                          <label class="b3 text-90">Start Date</label>
                          <p-calendar
                            class="b2 text-90"
                            formControlName="start_date"
                            placeholder="Start Date"
                            appendTo="body"
                            [iconDisplay]="'input'"
                            [showIcon]="true"
                            inputId="templatedisplay"
                          >
                            <ng-template
                              pTemplate="inputicon"
                              let-clickCallBack="clickCallBack"
                            >
                              <ng-icon
                                class="calendar-icon"
                                name="hugeCalendar03"
                                (click)="clickCallBack($event)"
                              />
                            </ng-template>
                          </p-calendar>
                        </div>
                        <div class="col-md-4">
                          <label class="b3 text-90">Planned End Date</label>
                          <p-calendar
                            class="b2 text-90"
                            formControlName="plan_end_date"
                            placeholder="Planned End Date"
                            appendTo="body"
                            [iconDisplay]="'input'"
                            [showIcon]="true"
                            inputId="templatedisplay"
                          >
                            <ng-template
                              pTemplate="inputicon"
                              let-clickCallBack="clickCallBack"
                            >
                              <ng-icon
                                class="calendar-icon"
                                name="hugeCalendar03"
                                (click)="clickCallBack($event)"
                              />
                            </ng-template>
                          </p-calendar>
                        </div>
                        <div class="col-md-4">
                          <label class="b3 text-90">Actual End Date</label>
                          <p-calendar
                            class="b2 text-90"
                            formControlName="actual_end_date"
                            placeholder="Actual End Date"
                            appendTo="body"
                            [iconDisplay]="'input'"
                            [showIcon]="true"
                            inputId="templatedisplay"
                          >
                            <ng-template
                              pTemplate="inputicon"
                              let-clickCallBack="clickCallBack"
                            >
                              <ng-icon
                                class="calendar-icon"
                                name="hugeCalendar03"
                                (click)="clickCallBack($event)"
                              />
                            </ng-template>
                          </p-calendar>
                        </div>
                      </div>

                      <div class="col-md-2">
                        @if(!(getMilestonesFields(i).length <= 1)) {
                        <button
                          type="button"
                          class="btn delete-btn m-b-20 b2 h-28 fs-12 wd-70"
                          (click)="removeMilestoneFields(i, j)"
                          [disabled]="getMilestonesFields(i).length <= 1"
                        >
                          Delete
                        </button>
                        }
                      </div>
                    </div>
                  </div>

                  <div class="col-md-2 offset-md-10">
                    <button
                      type="button"
                      class="btn outline b2 h-28 fs-12 wd-70"
                      (click)="addMoreMilestones(i)"
                    >
                      Add More
                    </button>
                  </div>

                  <!-- <div class="milestone-row">
                    <p-divider class="horizontal-divider" />
                  </div> -->
                  <!-- <div class="row m-t-10 m-b-15">
                    <div class="col-md-2">
                      @if(milestones.controls.length !== 1) {
                      <button class="btn delete-btn m-b-20 b2 h-28 fs-12 wd-70" (click)="milestones.removeAt(i)">Delete</button>
                      }
                    </div>


                    <div class="col-md-2 offset-md-8" *ngIf="(milestones.controls.length - 1) === i ">
                      <button class="btn outline b2 h-28 fs-12 wd-70" (click)="addMoreMilestones()">Add More</button>
                    </div>

                  </div> -->
                  <!-- <p-divider class="horizontal-divider" /> -->
                </div>
              </div>
            </p-scrollPanel>
          </div>
        </div>
        <div class="dis-flex flex-sb">
          <div class="dis-flex">
            <button
              type="button"
              *ngIf="isStartOver"
              class="btn black m-r-10 m-t-20"
              (click)="onStartOver(index)"
            >
              Start Over
            </button>
          </div>
          <div class="dis-flex">
            <button
              *ngIf="!isMileStoneDisabled"
              type="button"
              class="btn outline wd-100px m-r-10 m-t-20"
              (click)="onBackClick(prevCallback, milestonesForm, 'milestone')"
              [disabled]="isMileStoneDisabled"
            >
              Back
            </button>
            <button type="submit" class="btn success wd-100px m-t-20">
              Done
            </button>
          </div>
        </div>
      </form>
    </ng-template>
  </p-stepperPanel>
</p-stepper>
